import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuyNowService {

  private buyState = new Subject<boolean>();

  setBuy(status: boolean) {
    this.buyState.next(status);
  }

  getStatus(): Observable<any> {
    return this.buyState.asObservable();
  }

}
